module.exports = __webpack_public_path__ + "img/tomtat.946474f5.svg";